module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "List"
  }, [(_vm.componentParams.template == "articles") ? _c('articles', {
    attrs: {
      "data": _vm.api_response,
      "merge": _vm.merge_items,
      "locked": _vm.locked
    }
  }) : (_vm.componentParams.template == "portfolio") ? _c('portfolio', {
    attrs: {
      "data": _vm.api_response,
      "merge": _vm.merge_items,
      "locked": _vm.locked
    }
  }) : (_vm.componentParams.template == "catalog") ? _c('catalog', {
    attrs: {
      "data": _vm.api_response,
      "merge": _vm.merge_items,
      "locked": _vm.locked
    }
  }) : (_vm.componentParams.template == "more-projects") ? _c('more-projects', {
    attrs: {
      "data": _vm.api_response,
      "merge": _vm.merge_items,
      "locked": _vm.locked
    }
  }) : (_vm.componentParams.template == "index-projects") ? _c('index-projects', {
    attrs: {
      "data": _vm.api_response,
      "merge": _vm.merge_items,
      "locked": _vm.locked
    }
  }) : (_vm.componentParams.template == "index-articles") ? _c('index-articles', {
    attrs: {
      "data": _vm.api_response,
      "merge": _vm.merge_items,
      "locked": _vm.locked
    }
  }) : (_vm.componentParams.template == "index-news") ? _c('index-news', {
    attrs: {
      "data": _vm.api_response,
      "merge": _vm.merge_items,
      "locked": _vm.locked
    }
  }) : _vm._e(), _vm._v(" "), _c('pager', {
    attrs: {
      "total": _vm.totalPagesCount,
      "current": _vm.currentPageNumber,
      "locked": _vm.locked
    },
    on: {
      "goto": _vm.goto
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.loadMoreText) + "\n\t")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05f39f87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/List.vue
// module id = 375
// module chunks = 14